import React from 'react';
import PropTypes from 'prop-types';
import { Container, Text, GridItem, Box } from '@chakra-ui/react';
import { DeptGrid } from '@rsc/ui-components/dept/design-system';
import CardBlogStandard from '@rsc/ui-components/dept/atoms/CardBlogStandard';
import MiscNews from '@rsc/ui-components/dept/molecules/MiscNews';
import { generateSectionId } from '@rsc/ui-components/dept/utils/generateSectionId';
import SimpleSlider from '@rsc/ui-components/dept/molecules/SimpleSlider';

function CardBox(post) {
  const { badge, postReference } = post;
  return (
    <Box w={{ base: '17rem', sm: '30rem' }} h="full" mx="auto">
      <CardBlogStandard badge={badge} article={postReference} />
    </Box>
  );
}

export default function GridBlogPostCallout({ block, siteSettings }) {
  const { headline, cards } = block;

  return (
    <Container {...generateSectionId(block)} py={20}>
      {headline && (
        <Text as="h2" textStyle="h3" mb={10}>
          {headline}
        </Text>
      )}
      <DeptGrid display={{ base: 'none', lg: 'grid' }} gap={10}>
        <GridItem colSpan={{ md: 6, xl: 4 }} order={3}>
          <MiscNews h="full" newsletter={siteSettings.newsletter} />
        </GridItem>

        {cards.map((post, index) => (
          <GridItem key={post._key} colSpan={{ md: 6, xl: 4 }} order={index}>
            <CardBlogStandard badge={post.badge} article={post.postReference} />
          </GridItem>
        ))}
      </DeptGrid>

      <SimpleSlider
        items={cards}
        sliderItem={CardBox}
        display={{ base: 'block', lg: 'none' }}
      />
    </Container>
  );
}

GridBlogPostCallout.propTypes = {
  block: PropTypes.shape({
    headline: PropTypes.string,
    cards: PropTypes.arrayOf(
      PropTypes.shape({
        _key: PropTypes.string,
        badge: PropTypes.shape({
          headline: PropTypes.string,
          copy: PropTypes.string,
          link: PropTypes.shape({
            linkType: PropTypes.string,
            href: PropTypes.string,
            internalLink: PropTypes.shape({}),
          }),
          icon: PropTypes.shape({
            asset: PropTypes.shape({
              url: PropTypes.string,
            }),
          }),
        }),
      })
    ),
  }).isRequired,
  siteSettings: PropTypes.shape({
    newsletter: PropTypes.shape({
      newsletterTitle: PropTypes.string,
      newsletterDescription: PropTypes.string,
    }).isRequired,
  }).isRequired,
};
